import { PLP_DESCRIPTION_ROTATION_INTERVAL_MS } from '../../constants';
import { useEffect, useMemo, useState } from 'react';
import type { ListingDesignItem } from '../../domain/models/ProductListing';
import { getProductCardDescriptionLines } from './productCardDescription';

export function RotatingProductDescription({ product, className }: {
  product: ListingDesignItem;
  className?: string;
}) {
  const [lineIndex, setLineIndex] = useState(0);
  const lines = useMemo(() => getProductCardDescriptionLines(product), [product]);
  const lineKey = lines.join('|');
  const descriptionKey = `${product.designId}:${lineKey}`;
  const [previousDescriptionKey, setPreviousDescriptionKey] = useState(descriptionKey);
  if (previousDescriptionKey !== descriptionKey) {
    setPreviousDescriptionKey(descriptionKey);
    setLineIndex(0);
  }
  useEffect(() => {
    if (lines.length < 2) return;
    const timer = window.setInterval(() => setLineIndex(index => (index + 1) % lines.length), PLP_DESCRIPTION_ROTATION_INTERVAL_MS);
    return () => window.clearInterval(timer);
  }, [product.designId, lineKey, lines.length]);
  if (!lines.length) return null;
  return (
    <div className={className}>
      <span key={`${product.designId}-${lineIndex}`} className="animate-flip-in truncate whitespace-nowrap">{lines[lineIndex] ?? lines[0]}</span>
    </div>
  );
}
